import {useChatStore, useUserStore} from '@/stores'
import {useRepository, useSound} from '@/composables'
import {chat} from '@/messages'
import {mediator, messenger} from '@communication'


export default class ChatProcedure {
  constructor() {
    const {playSound} = useSound(['notification'])
    this.name = 'chatProcedure'
    this.chatStore = useChatStore()
    this.userStore = useUserStore()
    this.playSound = playSound
  }

  install = () => {
    messenger.subscribe(this.name, 'strategy:data', this.handler)
    messenger.subscribe(this.name, 'chat:history', this.handleHistory)
    messenger.subscribe(this.name, 'websocket:reconnecting', this.handlerChatOffline)
    messenger.subscribe(this.name, 'websocket:reconnected', this.handlerChatOnline)
  }

  uninstall = () => {
    messenger.unsubscribe(this.name)
  }

  handleHistory = event => {
    const history = JSON.parse(event.history)
    this.chatStore.clearMessages()
    const sortedMessages = this.sortMessagesByTimestamp(history);
    sortedMessages.forEach(item => {
      this.chatStore.addMessage({...item, author: this.userStore.id === item.partyId ? 'party' : 'counterparty'})
    })
  }

  sortMessagesByTimestamp = (messages) => {
    return messages.sort((a, b) => {
      const timeA = new Date(a.timestamp);
      const timeB = new Date(b.timestamp);
      return timeA - timeB;
    });
  }

  handler = (event, channel) => {
    if (channel === 'strategy:data') {
      const {type, text} = event
      if (type === 'chat:message') {
        const previewLength = 30
        const preview = text.length < previewLength ? text : text.substring(0, previewLength - 3) + '...'
        this.playSound('notification')
        this.chatStore.addMessage({...event, author: 'counterparty'})
        this.chatStore.previewMessage(preview)
      }
    }
  }

  handlerChatOffline = async () => {
    const isDisabledChat = true
    await this.chatStore.updateStatusChat(isDisabledChat)
  }

  handlerChatOnline = async () => {
    const isDisabledChat = false
    await this.chatStore.updateStatusChat(isDisabledChat)
  }

  send = data => {
    const {sendWsEvent} = useRepository()
    this.chatStore.addMessage({...data, author: 'party'})
    mediator.broadcast(chat.chatMessage(data))
    sendWsEvent(chat.chatMessage(data))
  }
}
